import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./Environment";

const container = document.getElementById("dlsmsl-https-app");
const root = createRoot(container);
root.render(<App tab="home" />);
